import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./page/PrivacyPolicy";
import TermsConditions from "./page/TermsConditions";
import CarWash from "./page/CarWash";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CarWash />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsConditions />} />
      </Routes>
    </Router>
  );
}

export default App;
